import React, { useState } from 'react'
import { v4 as uuid } from 'uuid'

const CPAAcordion = (props) => {
	const {
		titleAccordion,
		indexCar,
		CharactBlock
	} = props
	let totalCaract = 0;
	const [detailsCond, setDetailsCond] = useState(false)

	const mostrarOpciones = detailsCond ? {
		display: 'block'
	}: {display: 'none'}
	
  	return (
		<>
			<dl className="genAccItem">
				<dt className={`genAccTitle ${detailsCond ? 'active':''}`}  onClick={()=>{setDetailsCond(c=>!c)}}> 
					<h5>{titleAccordion}</h5>
				</dt>
				<dd className={`genAccCont ${detailsCond ? 'openDetails':''}`} style={mostrarOpciones}>
				{					
                    CharactBlock ?					
                  	  CharactBlock.map((caract, index) => {
							if(index >= indexCar) {
								if(caract.fi_TIPO_VALOR_CARACTERISTICA === 8) {
									totalCaract++;
								}
							}
							return index >= indexCar && totalCaract === 0 ?
								<dl key={uuid()} className="cPlanAccordionTable"  >
									<dt> 
										<p> <strong>{caract.fc_TITULO}</strong></p>
									</dt>
									<dd> 
										<p> <strong>{caract.fc_VALOR}</strong></p>
									</dd>
								</dl>
								: null
					  })
					  :null
				}	
				</dd>
			</dl>
		</>
  	)
}

export default CPAAcordion
